<template>
  <client-only>
    <v-row justify-content="start" class="flex-column" v-if="description.length > 1">
      <v-col
        class="company--details"
        :class="[langCheck ? 'text-right' : 'text-left']"
      >
        <div :class="[address ? 'company--details--inner' : '']">
          <h2 class="h3 pr-3 white--text">{{ textForTitle }}</h2>
          <TextContent
            :content="description"
            :fontSizeTitle="sizeForTitle"
            :showTitle="true"
            :isMobile="isMobile"
            :toShowMore="true"
          />
          <!-- <CompanyLocation :address="address" v-if="isMobile" /> -->
        </div>
      </v-col>

      <!-- <v-col class="location--details" v-if="address && !isMobile">
        <v-row class="flex-column">
          <v-col
            class="company-location"
            v-if="!isMobile"
            :class="[address ? 'location--details--inner' : '']"
          >
            <CompanyLocation :address="address" />
          </v-col>

          <v-col class="how-long px-0 d-md-flex" v-if="address">
            <CalculateDistance
              :address="address"
              :latitude="latitude"
              :longitude="longitude"
              :isMobile="isMobile"
            />
          </v-col>
        </v-row>
      </v-col> -->
    </v-row>
  </client-only>
</template>

<script>
import TextContent from '@/components/Wrappers/Text/Text';

//import CompanyLocation from '@/components/Company/CompanyLocation';
//import CalculateDistance from '@/components/Company/CalculateDistance';

const MOBILE = 'display-16';
const DESKTOP = 'display-56';

export default {
  components: {
    TextContent,
    //CompanyLocation,
    //CalculateDistance,
  },

  props: {
    description: {
      type: String,
    },
    companyName: {
      type: String,
    },
    address: {
      type: String,
    },
    numOfEmployees: {
      type: String,
    },
    industry: {
      type: String,
    },
    numOfBranches: {
      type: Number,
    },
    latitude: {
      type: Number,
    },
    longitude: {
      type: Number,
    },
    isMobile: {
      type: Boolean,
    },
  },

  data() {
    return {
      text: 'אודות',
    };
  },

  mounted() {
    this.textForTitle;
    this.sizeForTitle;
  },

  computed: {
    langCheck() {
      var position = this.description.search(/[\u0590-\u05FF]/);
      if (position >= 0) {
        return true;
      }
      return false;
    },
    textForTitle() {
      return this.text + ' ' + this.companyName;
    },

    sizeForTitle() {
      return this.isMobile ? DESKTOP : MOBILE;
    },
  },
};
</script>

<style lang="scss" scoped>
.company--details {
  background-color: #3e4a54;
  color: #fff;
  max-width: initial;
  h3 {
    padding-right: 14px;
  }
}
.company--details--inner {
  padding: 20px;
}

.location--details {
  background-color: $primary;
  text-align: center;
}

</style>
